import { Button, homeIcon, laptopPencilIcon, personIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { trackAnalytics } from "@repo/utils";
import { useEffect, useRef } from "react";

import { ActionBar } from "./ProjectsTable.styled";
import { type EditModalMode } from "./utils";

interface TableActionButtonsProps {
  setEditModalMode: (mode: EditModalMode) => void;
}

export const TableActionButtons = ({
  setEditModalMode,
}: TableActionButtonsProps) => {
  const actionBarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    actionBarRef.current?.focus();
  }, []);

  return (
    <ActionBar
      ref={actionBarRef}
      tabIndex={-1}
      role="toolbar"
      aria-label={t("label.actions")}
    >
      <Button
        text={t("action.assign_to_coworker")}
        ssrIcon={personIcon}
        type="secondary"
        size="small"
        onClick={() => {
          setEditModalMode("assign");
          trackAnalytics("assign_to_coworker");
        }}
      />
      <Button
        text={t("action.change_cmp")}
        ssrIcon={homeIcon}
        type="secondary"
        size="small"
        onClick={() => {
          setEditModalMode("cmp");
          trackAnalytics("change_customer_meeting_point");
        }}
      />
      <Button
        text={t("action.change_status")}
        ssrIcon={laptopPencilIcon}
        type="secondary"
        size="small"
        onClick={() => {
          setEditModalMode("status");
          trackAnalytics("change_status");
        }}
      />
    </ActionBar>
  );
};
